// node_modules
import { useEffect } from "react";

export const useHash = (hashChangeHandler: () => void): {
    removeHashFromURL: () => void
} => {
    // Logic
    // when component using the hook is bootstrapped
    useEffect(() => {
        // if there already is a hash in the URL, call hashChangeHandler function
        if (window.location.hash) {hashChangeHandler();}

        // add an event listener on hashchange event
        window.addEventListener("hashchange", hashChangeHandler, false);
        return () => window.removeEventListener("hashchange", hashChangeHandler, false);
    }, [hashChangeHandler]);

    const removeHashFromURL = (): void => {
        const url = `${window.location.pathname} ${window.location.search}`;
        window.history.replaceState(
            {}, 
            document.title, 
            url
        );
    };

    return { removeHashFromURL };
};
